















































































































import Vue from 'vue'
import SocialStreamConfigStore from '@/store/socialStream/socialStreamConfig'
import { LocaleMessages } from 'vue-i18n'

export default Vue.extend({
  components: {},
  computed: {
    instagramHandle: {
      get() {
        return SocialStreamConfigStore.state.data.socialStreamConfig.instagramHandle
      },
      set(value) {
        SocialStreamConfigStore.dispatch('updateInstagramHandle', value)
      },
    },
    labelSocialStreamInstagramHandle(): string | LocaleMessages {
      return this.$t('socialStream.config.label.instagramHandle')
    },
    includedHashTag: {
      get() {
        return SocialStreamConfigStore.state.data.socialStreamConfig.includedHashTag
      },
      set(value) {
        SocialStreamConfigStore.dispatch('updateIncludedHashTag', value)
      },
    },
    labelSocialStreamIncludedHashTag(): string | LocaleMessages {
      return this.$t('socialStream.config.label.includedHashTag')
    },
    influencerSubpage: {
      get() {
        return SocialStreamConfigStore.state.data.socialStreamConfig.influencerSubpage
      },
      set(value) {
        SocialStreamConfigStore.dispatch('updateInfluencerSubpage', value)
      },
    },
    labelSocialStreamInfluencerSubpage(): string | LocaleMessages {
      return this.$t('socialStream.config.label.influencerSubpage')
    },
    influencerSubpageHeader: {
      get() {
        return SocialStreamConfigStore.state.data.socialStreamConfig.influencerSubpageHeader
      },
      set(value) {
        SocialStreamConfigStore.dispatch('updateInfluencerSubpageHeader', value)
      },
    },
    labelSocialStreamInfluencerSubpageHeader(): string | LocaleMessages {
      return this.$t('socialStream.config.label.influencerSubpageHeader')
    },
    influencerProfileImage: {
      get() {
        return SocialStreamConfigStore.state.data.socialStreamConfig.influencerProfileImage
      },
      set(value) {
        SocialStreamConfigStore.dispatch('updateInfluencerProfileImage', value)
      },
    },
    labelSocialStreamInfluencerProfileImage(): string | LocaleMessages {
      return this.$t('socialStream.config.label.influencerProfileImage')
    },
    clickThrough: {
      get() {
        return SocialStreamConfigStore.state.data.socialStreamConfig.clickThrough
      },
      set(value) {
        SocialStreamConfigStore.dispatch('updateClickThrough', value)
      },
    },
    labelSocialStreamClickThrough(): string | LocaleMessages {
      return this.$t('socialStream.config.label.clickThrough')
    },

    filterAvailable: {
      get() {
        return SocialStreamConfigStore.state.data.socialStreamConfig.filterAvailable
      },
      set(value) {
        SocialStreamConfigStore.dispatch('updateFilterAvailable', value)
      },
    },
    labelSocialStreamFilterAvailable(): string | LocaleMessages {
      return this.$t('socialStream.config.label.showOnlyAvailable')
    },
  },
  mounted() {
    SocialStreamConfigStore.dispatch('getSocialStreamConfig', (typeof this.$route.params.configId !== 'undefined') ? this.$route.params.configId : '')
  },
  methods: {
    getValidationState(validation: { validated: boolean, valid: boolean | null }) {
      return validation.validated ? validation.valid : null
    },
    onSubmit() {
      const storeResult = SocialStreamConfigStore.dispatch('storeSocialStreamConfig')

      storeResult
        .then(success => {
          this.$router.push({ name: 'socialStreamConfigs' })
            .catch(() => {})
          return success
        })
        .catch(() => {
          console.log('something went wrong')
        })
    },
  },
})
